﻿import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/pg_sistema/sistema-parametros";

export const Route = createFileRoute("/_authenticated/sistema-parametros")({
  head: () => ({
    meta: [
      { title: "Parâmetros — Milky Moo Palmares" },
      {
        name: "description",
        content: "Royalties, impostos e marketing aplicados aos produtos do sistema de estoque.",
      },
      { property: "og:title", content: "Parâmetros — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Royalties, impostos e marketing aplicados aos produtos do sistema de estoque.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});
